import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2CommonData,
    TBFL2CommonFields,
} from '../@types';
import MARPOLModule from '../../marpol/operation.types';
import { TBFL2BackendRecord } from '../@types';

export type TBFL2I1Item1 = {
    otherDeviations: string;
    recordAttachment: string;
};

export type TBFL2I1 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2I1;
        item1: TBFL2I1Item1;
    };

export type TBFL2I2Item1 = MARPOLModule.MissedEntryItem<TBFL2BackendRecord>;

export type TBFL2I2 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2I2;
        item1: TBFL2I2Item1;
    };

export type TBFL2I = TBFL2I1 | TBFL2I2;

const BFL2I_DEFAULTS: {
    I1: TBFL2I1;
    I2: TBFL2I2;
} = {
    I1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            otherDeviations: '',
            recordAttachment: ' ',
        },
        recordCode: EBFL2RecordCode.BFL2I1,
    },
    I2: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            dateOfOriginalOperation: '',
            isAnMissedEntryRecord: true,
            missedRecord: undefined,
            receiptAttachment: ' ',
        },
        recordCode: EBFL2RecordCode.BFL2I2,
    },
};

export { BFL2I_DEFAULTS };
